import React from "react";
import { MCheckbox, MSelect, ValidatedForm } from "components/forms";
import { Container, Col, Row } from "design-react-kit";
import { payloadBuilder } from "libs";

export class DichiarazioneEccedenze extends ValidatedForm {
  emptyFields = {
    checkEccedenze: false,
    istitution: "",
    description: "",
  };

  institutions = [
    { label: "Selezionare", value: "" },
    {
      label: "Istituto Nazionale di Documentazione, Innovazione e Ricerca Educativa (INDIRE)",
      value: "Istituto Nazionale di Documentazione, Innovazione e Ricerca Educativa (INDIRE)",
    },
    {
      label: "Università della Basilicata",
      value: "Università della Basilicata",
    },
    { label: "Università della Calabria", value: "Università della Calabria" },
    {
      label: "Università Mediterranea di Reggio Calabria",
      value: "Università Mediterranea di Reggio Calabria",
    },
    {
      label: "Università Suor Orsola Benincasa di Napoli",
      value: "Università Suor Orsola Benincasa di Napoli",
    },
    {
      label: `Università Telematica "Giustino Fortunato"`,
      value: `Università Telematica "Giustino Fortunato"`,
    },
    {
      label: `Università Telematica "Pegaso"`,
      value: `Università Telematica "Pegaso"`,
    },
    { label: "Università di Parma", value: "Università di Parma" },
    {
      label: "Università di Cassino e del Lazio meridionale",
      value: "Università di Cassino e del Lazio meridionale",
    },
    {
      label: "Università Europea di Roma",
      value: "Università Europea di Roma",
    },
    {
      label: `Università degli Studi di Roma "Foro Italico"`,
      value: `Università degli Studi di Roma "Foro Italico"`,
    },
    {
      label: `Libera Università "Maria SS Assunta" - LUMSA di Roma`,
      value: `Libera Università "Maria SS Assunta" - LUMSA di Roma`,
    },
    {
      label: `Università "Saint Camillus International"`,
      value: `Università "Saint Camillus International"`,
    },
    {
      label: `Università Telematica "Universitas Mercatorum"`,
      value: `Università Telematica "Universitas Mercatorum"`,
    },
    {
      label: "Università Cattolica Sacro Cuore",
      value: "Università Cattolica Sacro Cuore",
    },
    { label: "Università della Tuscia", value: "Università della Tuscia" },
    {
      label: `Università di Urbino "Carlo Bò"`,
      value: `Università di Urbino "Carlo Bò"`,
    },
    { label: "Università di Foggia", value: "Università di Foggia" },
    { label: "Università del Salento", value: "Università del Salento" },
    { label: "Università di Palermo", value: "Università di Palermo" },
    { label: "Università di Siena", value: "Università di Siena" },
    { label: "Università di Perugia", value: "Università di Perugia" },
    { label: "Università di Verona", value: "Università di Verona" },
    { label: "Università di Bologna", value: "Università di Bologna" },
    { label: "Università di Roma Tre", value: "Università di Roma Tre" },
    {
      label: "Università Studi Internazionali di Roma - UNINT",
      value: "Università Studi Internazionali di Roma - UNINT",
    },
    { label: "Università di Cagliari", value: "Università di Cagliari" },
    { label: "Università di Firenze", value: "Università di Firenze" },
    {
      label: "Università Modena-Reggio Emilia",
      value: "Università Modena-Reggio Emilia",
    },
    {
      label: "Università telematica Unicusano - Roma",
      value: "Università telematica Unicusano - Roma",
    },
    { label: "Università di Macerata", value: "Università di Macerata" },
    { label: "Università di Bari", value: "Università di Bari" },
    { label: "Università di Padova", value: "Università di Padova" },
    { label: "Università di Salerno", value: "Università di Salerno" },
    {
      label: `Università degli Studi "Link Campus University"`,
      value: `Università degli Studi "Link Campus University"`,
    },
    {
      label: `Università telematica "e-Campus"`,
      value: `Università telematica "e-Campus"`,
    },
    { label: "Università del Molise", value: "Università del Molise" },
    {
      label: `Università LUM "Giuseppe Degennaro"`,
      value: `Università LUM "Giuseppe Degennaro"`,
    },
    { label: "Università di Messina", value: "Università di Messina" },
    {
      label: "Università per Stranieri di Reggio Calabria",
      value: "Università per Stranieri di Reggio Calabria",
    },
    {
      label: `Università UKE "Kore" di Enna`,
      value: `Università UKE "Kore" di Enna`,
    },
  ];

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  FIELDS_GROUP = [
    [
      {
        id: "istitution",
        field: "istitution",
        label: "Presso",
        component: MSelect,
        payload: { options: this.institutions },
        className: "col-md-6",
      },
      {
        id: "description",
        field: "description",
        label: "Ordine di scuola",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Scuola Primaria", value: "PRIMARIA" },
            {
              label: "Scuola Secondaria di I Grado",
              value: "I GRADO",
            },
            {
              label: "Scuola Secondaria di II Grado",
              value: "II GRADO",
            },
          ],
        },
        className: "col-md-6",
        readOnly: true,
      },
    ],
  ];

  ERROR_MESSAGES = {
    istitution: "Campo obbligatorio",
    description: "Campo obbligatorio",
  };

  validation = {
    istitution: (value) => value !== "",
    description: (value) => value !== "",
  };

  componentDidMount() {
    const { defaultPayload, grado } = this.props;

    const newState = {
      description: grado,
      defaultValues: {
        ...this.state.defaultValues,
        description: grado,
      },
    };

    if (defaultPayload && defaultPayload.length > 0) {
      const eccedenze = defaultPayload[0];
      newState.defaultValues = { ...newState.defaultValues, ...eccedenze };
      newState.checkEccedenze = true;
    }

    this.setState(newState);
  }

  onSubmit = () => {
    const { checkEccedenze } = this.state;

    let isValid = true;
    if (checkEccedenze) {
      isValid = this.checkValidation();
    }

    return isValid;
  };

  getPayload = () => {
    if (!this.state.checkEccedenze) {
      return null;
    }

    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = "Eccedenze";
    this.payload.extCode = "Title15_Eccedenze";
    this.payload.qualificationCode = "title15";
    this.payload.template = "Title15_Eccedenze";

    return this.payload;
  };

  onChangeCheckEccedenze = (id, value) => {
    this.setState({ checkEccedenze: value });
  };

  //--- ---

  render() {
    const { checkEccedenze, defaultValues } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <Container>
        <Row>
          <Col>
            <MCheckbox
              name="checkEccedenze"
              id="checkEccedenze"
              value={checkEccedenze}
              onChange={this.onChangeCheckEccedenze}
              label="Rientro tra le eccedenze del primo ciclo di formazione, ai sensi dell'art. 6 comma 3 del DM n. 75 del 24 aprile 2025"
            />
          </Col>
        </Row>

        {checkEccedenze && <div className="mt-3 p-3">{code}</div>}
      </Container>
    );
  }
}
